import Vue from 'vue';
// const PDFViewer = Vue.extend(require('./PDFViewer.vue'));
// import PDFViewer from './PDFViewer.vue'
const PDFViewer = Vue.extend(require('./PDFViewer.vue'))
let pdfViewerInstance
const pdfViewer = function (options) {
  // 生成组件

  // 组件需要挂载在dom元素上
  // const pdfviewerEl = document.querySelectorAll('.common_pdfviewer_wrapper')


  if (!pdfViewerInstance) {
    pdfViewerInstance = new PDFViewer({
      // innerData: options.fileData
    });
    pdfViewerInstance.vm = pdfViewerInstance.$mount();
    pdfViewerInstance.dom = pdfViewerInstance.vm.$el;
    document.body.appendChild(pdfViewerInstance.dom);
  }
  pdfViewerInstance.visible = true;
  pdfViewerInstance.innerData = options.fileData
  pdfViewerInstance.title = options.title
  pdfViewerInstance.fileName = options.fileName
  pdfViewerInstance.download = options.download
  pdfViewerInstance.s3Path = options.s3Path

};

export default {
  install(Vue, options) {
    Vue.prototype.$PDFViewer = pdfViewer
  }
};

// export default pdfViewer



// WEBPACK FOOTER //
// ./src/libs/PDFViewer/index.js